// removed by extract-text-webpack-plugin
module.exports = {"container":"_3cQNBlooyh5SpUczMsIPI7","userImage":"_1BRHBePgeB2VwyqkRx1r8Q","activity":"_2rVAlc7I3vRbFDFAJWTNUJ","type":"oCgrwcepiHnJpnnjp3y6U","date":"_9Z-qMh6MmtOpj2JsrkWBB","message":"MmoE-GdlyUc07lsQ3UVpI"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3940a03f","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Home/Focus/FocusComment.less
// module id = r3c3
// module chunks = 1